/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-configuration-integrations .button-action-integration-disabled{cursor:default;opacity:.5;pointer-events:none}"];
export { styles as styles };
